import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { PlotlyTrace, PlotlyLayout } from '@app/types';
import { ChartType, IChartTypeConfig } from '@common/models/Chat/IChartConfig';
import { IChatInteractionResponseTable } from '@common/models/Chat/IChatResponse';
import { PlotterService } from '@app/services/plotter.service';

@Component({
  selector: 'app-chart-visualizer',
  templateUrl: './chart-visualizer.component.html',
  styleUrls: ['./chart-visualizer.component.scss']
})
export class ChartVisualizerComponent implements OnInit, OnChanges {
  @Input() chartType: ChartType;
  @Input() chartTitle: string;
  @Input() chartConfig: IChartTypeConfig;
  @Input() tableData: IChatInteractionResponseTable;

  plotlyData: PlotlyTrace[] = [];
  plotlyLayout: PlotlyLayout = {};
  plotlyConfig = {
    displaylogo: false,
    showTips: false,
    toImageButtonOptions: {
      format: 'png',
      filename: 'chart',
    },
  };

  constructor(private readonly plotterService: PlotterService) {}

  ngOnInit(): void {
    this.buildChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['chartType'] || changes['chartTitle'] || changes['chartConfig'] || changes['tableData']) {
      this.buildChart();
    }
  }

  private buildChart(): void {
    if (!this.chartType || !this.chartConfig || !this.tableData) {
      return;
    }

    const plotlyConfig = this.plotterService.plot(this.tableData, this.chartType, this.chartTitle, this.chartConfig);

    if (plotlyConfig) {
      this.plotlyData = plotlyConfig.data;
      this.plotlyLayout = {
        ...plotlyConfig.layout,
        autosize: true,
      };
    }
  }
}
